export default {
  methods: {
    orderDecisionInfo(term) {
      return `
        OTB Calculation Configuration<br>
        Return Rentals To Subtract: ${term['returnRentalsToSubtract']}<br>
        Buyback To Subtract: ${term['buybackToSubtract']}<br>
        Subtract Order Short: ${term['subtractOrderShort'] == true ? 'Yes' : 'No'}`;
    },
  }
};